<template lang="pug">
  .auth--confirm
    img.auth__logo(:alt="appName" :src="logoPath")

    form.auth__form(
      v-if="!success && !fails && !failsNotExist"
      @submit.prevent="registerUser")
      input(
        type="text"
        name="name"
        v-model="name"
        v-validate="'required|max:35|min:2'"
        :data-vv-as="$t('name')"
        :class="{'error': errors.has('name') }"
        :placeholder="$t('name')"
        autofocus)

      input(
        type="text"
        name="lastName"
        v-model="lastName"
        v-validate="'required|max:35|min:2'"
        :data-vv-as="$t('lastName')"
        :class="{'error': errors.has('lastName') }"
        :placeholder="$t('lastName')")

      input(
        type="email"
        name="email"
        v-model="email"
        v-validate="'required|email'"
        :data-vv-as="$t('email')"
        :class="{'error': errors.has('email') }"
        :placeholder="$t('email')"
        disabled)

      .auth__password
        input(
          :type="passwordField"
          name="password"
          v-model="password"
          v-validate="'required|max:64|min:8'"
          :data-vv-as="$t('password')"
          :class="{'error': errors.has('password') }"
          :placeholder="$t('password')")
        .togglePassword(@click="togglePassword")
          van-icon(:name="passwordIcon")

      .margin-halve-top
        .auth__error(v-show="errors.has('name')") {{ errors.first('name') }}
        .auth__error(v-show="errors.has('lastName')") {{ errors.first('lastName') }}
        .auth__error(v-show="errors.has('email')") {{ errors.first('email') }}
        .auth__error(v-show="errors.has('password')") {{ errors.first('password') }}

      //- .checkbox.margin-top
      //-   input(
      //-     type="checkbox"
      //-     name="toc"
      //-     v-model="toc"
      //-     v-validate="'required'"
      //-     :data-vv-as="$t('terms.terms')"
      //-     :class="{'error': errors.has('toc') }")
      //-   label(for="toc")
      //-     | {{ $t('terms.init') }}
      //-     a.link(v-if="certTerms" :href="certTerms" target="_blank")  {{ $t('terms.terms') }}
      //-     |  {{ $t('terms.second') }}
      //-  a.link(v-if="certPrivacy" :href="certPrivacy" target="_blank")  {{ $t('terms.privacy') }}
      //-     | {{ $t('terms.finish') }}


      //- .checkbox.margin-quarter-top
      //-   input(
      //-     type="checkbox"
      //-     name="commercial"
      //-     v-model="commercial")

      //-   label(for="commercial")
      //-     | {{ $t('authorize') }}

      //- Terms of Use checkbox
      .margin-top {{ $t('authorize', { app: appName }) }}

      //- Commercial notification checkbox
      .checkbox.margin-quarter-top.padding-left
        input(
          type="checkbox"
          name="commercial"
          v-model="commercial")

        label(for="commercial")
          | {{ $t('marketing') }}

      //- Commercial notification checkbox
      .checkbox.margin-quarter-top.padding-left(v-if="showSupportEmail")
        input(
          type="checkbox"
          name="support"
          v-model="support")

        label(for="support")
          | {{ $t('support') }}

      hr.padding-top.padding-bottom

      .margin-halve-bottom {{ $t('agree')}}
      ul.links
        li(v-if="certTerms")
          a.link(:href="certTerms" target="_blank") {{ $t('terms.terms') }}
        li(v-if="certLicense")
          a.link(:href="certLicense" target="_blank") {{ $t('terms.license') }}
        li(v-if="certPrivacy")
          a.link(:href="certPrivacy" target="_blank") {{ $t('terms.privacy') }}

      van-button(
        size="large"
        type="primary"
        native-type="submit") {{ $t('send') }}


    //- Fails get email
    .text--center(v-if="failsNotExist")
      van-icon(name="error")
      h1 {{ $t('errors.userNotExist.title')}}
      p {{ $t('errors.userNotExist.message')}}

    //- Succes send email confirm
    .text--center(v-if="success")
      van-icon(name="succes")
      h1 {{ $t('messages.invitedUser.title')}}
      p {{ $t('messages.invitedUser.message')}}

    //- Fails send email confirm
    .text--center(v-if="fails")
      van-icon(name="error")
      h1 {{ $t('errors.general.title')}}
      p {{ $t('errors.general.message')}}
</template>

<script>
import i18n from "@/i18n";
import axios from "axios";
import router from "@/router";
import { PROYECT } from "@/constant";

export default {
  data() {
    return {
      appName: PROYECT.NAME,
      logoPath: `/${PROYECT.LOGO}.svg`,
      name: "",
      lastName: "",
      email: "",
      password: "",
      toc: true,
      support: true,
      commercial: true,
      success: false,
      fails: false,
      failsNotExist: false,
      passwordField: "password",
      passwordIcon: "hide",
      certPrivacy: null,
      certLicense: null,
      certTerms: null,
      showSupportEmail: PROYECT.SHOW_SUPPORT_EMAIL
    };
  },
  methods: {
    /*
     * Toggle Password input
     */
    togglePassword() {
      this.passwordField = this.passwordField === "password" ? "text" : "password";
      this.passwordIcon = this.passwordField === "password" ? "hide" : "show";
    },

    getCertPrivacy(language) {
      return PROYECT.APP.PRIVACY[language] || PROYECT.APP.PRIVACY.EN;
    },

    getCertLicense(language) {
      return PROYECT.APP.LEGAL[language] || PROYECT.APP.LEGAL.EN;
    },

    getCertTerms(language) {
      return PROYECT.APP.TERMS[language] || PROYECT.APP.TERMS.EN;
    },

    registerUser() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$toast.loading({
            duration: 0,
            mask: true,
            message: i18n.t("loading")
          });

          const { token } = this.$route.params;
          const data = {
            email: this.email,
            password: this.password,
            lang: i18n.locale,
            data: {
              name: this.name,
              lastName: this.lastName,
              toc: this.toc,
              commercial: this.commercial,
              support: this.support
            }
          };

          axios({ url: `auth/confirmSignup/${token}`, data, method: "POST" })
            .then(() => {
              this.$toast.clear();
              this.success = true;
            })
            .catch(() => {
              this.$toast.clear();
              this.fails = true;
            });
        }
      });
    }
  },
  created() {
    const language = i18n.locale.toUpperCase();
    this.certPrivacy = this.getCertPrivacy(language);
    this.certTerms = this.getCertTerms(language);
    this.certLicense = this.getCertLicense(language);

    /*
     * AZ no tiene habilitada esta funcionalidad,
     * si alguien llega aquí lo redirijo al home
     */
    if (PROYECT.HOST === "AZ") {
      router.push({ name: "home" });
    }

    this.$toast.loading({
      duration: 0,
      mask: true,
      message: i18n.t("loading")
    });

    const { token } = this.$route.params;

    axios({ url: `auth/checkUserHash/${token}`, method: "GET" })
      .then(resp => {
        this.$toast.clear();
        this.email = resp.data.email;
      })
      .catch(error => {
        this.$toast.clear();
        const errorId = error.response && error.response.data ? error.response.data._id : null; // eslint-disable-line

        switch (errorId) {
          case "userNotExist":
            this.failsNotExist = true;
            break;
          default:
            this.fails = true;
        }
      });
  }
};
</script>
